{
  "Notifications": "Notificaciones",

  "CreatedAnEvent": "creó un evento",
  "FormerRebel": "Antiguo Rebelde",

  "DeletedAnEvent": "eliminó un evento",
  "a": " una ",
  "an": " un ",
  "SeeAll": "Ver todo",

  "ChangedTheDetails": "cambió los detalles del evento",
  "Name": "Nombre",
  "DateTime": "Fecha y hora",
  "to": "a",
  "Location": "Ubicación",
  "IsNowHappeningOnline": "Ahora mismo está sucediendo online",

  "InvitedYouToAttendAnEvent": "te invitó a asistir a un evento",
  "YouAreAttendingAs": "Asistirás como ",
  "SeeEvent": "Ver evento.",
  "YouAreNotGoing": "No vas a este evento",
  "decline": "rechazar",
  "accept": "aceptar",
  "BoostedYourPost": "impulsó tu publicación en",

  "posted": "publicado",
  "in": "en",
  "admin": " (administrador)",
  "PostDeleted": "Publicación eliminada",
  "RepliedToYourPost": "respondió a tu publicación en",
  "RespondedToThread": "respondió a un hilo del que eres parte en",

  "InvitedYouToHub": "te invitó a un centro",
  "YouAreNow": "Ahora eres",
  "aMember": "un miembro",
  "SeeHubEvents": "Ver eventos del hub.",
  "YouDeclinedThisInvitation": "Rechazaste esta invitación.",

  "InvitedYouToTheirTeam": "te invitó a su equipo",
  "ignore": "ignorar",
  "WelcomeToTheTeam": "¡Bienvenido al equipo!",
  "GoToProject": "Ir al proyecto.",
  "Ignored": "Ignorado",

  "SentYouKudos": "te mando kudos",
  "PlusOneKudos": "+1 punto de kudos",

  "SentYouNote": "te envió una nota",

  "UpdatedThe": "actualizado el",
  "builder": "builder",

  "JustRSVPd": "sólo ha respondido SÍ! a",

  "JoinedYourHub": "se unió a tu hub",

  "JoinedYourProject": "se unió a tu proyecto",

  "LeftYourProject": "abandonó tu proyecto",

  "SubmittedProject": "presentó un proyecto,",
  "ForTheEvent": "para el evento",

  "NoNotifications": "Sin notificaciones",
  "end": "fin",
  "Invites": "Invitaciones",
  "NoInvitesRightNow": "no hay invitaciones en este momento",

  "ProfileImageUploaded": "Imagen de perfil cargada correctamente",
  "SupportedFormats": "El formato de imagen no es compatible. Los formatos admitidos son jpg, jpeg, png, gif y jfif.",
  "MandatoryField": "Hm ... parece que nos saltamos un campo obligatorio.",
  "InvalidEmail": "No reconocemos este correo electrónico válido, ¡es posible que seas de otro mundo!",
  "MessageSent": "¡Tu mensaje ha sido enviado! Nos comunicaremos contigo en breve, lo prometo.",
  "RequiredFields": "Por favor, rellena todos los campos obligatorios.",
  "ProjectNameAlreadyExists": "Oh vaya! Este nombre de proyecto ya está en uso. Seleccione otro nombre. Bueno, ¡es otra oportunidad para ser creativo!",
  "ClickHere": "Haz clic aquí",
  "InviteTeammatesHere": "Invita a tus compañeros de equipo a tu proyecto aquí:",
  "InviteTeammates": "Invitar compañeros de equipo",
  "CreateProject": "Crea un Proyecto",

  "EmailVerified": "¡Correo verificado!",
  "InvalidToken": "¡Simbolo no valido!",
  "EmailVerificationSent": "Un email de verificación ha sido enviado a",
  "VerifyHere": "Haz clic en el enlace para verificar.",
  "VerifyEmail": "Por favor verifica tu dirección de correo electrónico:",
  "SendVerificationEmail": "Envia un correo electronico de verificación",

  "EnterNameAndUploadLogo": "Escribe un nombre y añade un logotipo.",
  "EnterValidWebsiteURL": "Introduce una URL de sitio web válida.",
  "EnterName": "Escrive un nombre.",
  "MinProjectRequirement": "Debe haber al menos un proyecto para comenzar a juzgar.",
  "Error": "¡Ups! Algo salió mal.",
  "SelectWinningTeams": "¡Ups! Selecciona los equipos ganadores.",
  "Round": "Ronda",
  "RoundPart2": "ya está lista!",
  "HubCreated": "Hub creado con éxito! Cuéntanos un poco sobre tu hub.",
  "HubDetailsUpdated": "Hub details updated.",
  "EnterAllRequiredFields": "Escribe todos los campos obligatorios.",
  "EnterEventLocation": "Dinos dónde se llevará a cabo el evento o, si es online, marca la casilla online.",
  "EventEnding": "Oh no. tu evento parece terminar antes de que haya comenzado.",
  "EventUpdated": "Evento actualizado correctamente.",
  "EventDeleted": "Evento eliminado correctamente.",
  "SelectProject": "Selecciona un proyecto.",
  "ProjectSubmitted": "Proyecto enviado!",
  "AdminCardUpdated": "Tarjeta de administrador actualizada correctamente.",
  "SupportCardUpdated": "Tarjeta de soporte actualizada correctamente.",
  "FillAllFields": "Por favor llena todos los espacios.",

  "SignupOrLoginFirst": "Regístrate o inicia sesión antes de intentar aceptar una invitación para crear un Hub.",
  "LoginWithCorrectEmail": "¡Asegúrese de haber iniciado sesión con el correo electrónico correcto antes de intentar aceptar una invitación!",
  "InvitationExpired": "¡Esta invitación ha caducado!",
  "EnterEmailToInvite": "Escribe una dirección de correo electrónico para invitar.",
  "UserAlreadyHubMember": "Este usuario ya es miembro del hub o tiene una invitación pendiente.",
  "InvitationSent": "Invitación enviada!",
  "InvitationResent": "¡Invitación reenviada!",
  "InvitationDeleted": "Invitación eliminada.",
  "InvitationAccepted": "Invitación aceptada con éxito.",
  "TokenInvalid": "Ficha Invalida",
  "InvalidEmails": "Los siguientes correos electrónicos no son válidos:",
  "EnterEmailsToInvite": "Escribe algunos correos electrónicos para invitar. Si deseas hacer esto más tarde, puedes omitir este paso.",
  "EnterSomeEmails": "Escribe algunos correos electrónicos para invitar.",
  "YouAreInvitingYourself": "Estás intentando invitarte al evento:",
  "AlreadyInvited": "Los siguientes correos electrónicos ya están invitados o asistiendo al evento:",
  "SelectRoleType": "Selecciona un tipo de función antes de enviar invitaciones.",
  "InvitationsSent": "Invitaciones enviadas con éxito.",
  "SignupOrLogin": "Regístrate o inicia sesión antes de intentar aceptar una invitación a un evento.",

  "NoAccount": "¡Ups! No hay ninguna cuenta asociada a este correo electrónico.",
  "CheckYourEmail": "¡Revisa tu correo electrónico para encontrar un enlace para restablecer su contraseña!",
  "FillInAllFields": "Asegúrate de completar todos los campos.",
  "EnterFieldsProperly": "Asegúrate de que los campos se escriben correctamente.",
  "PasswordReset": "¡Contraseña restablecida correctamente!",

  "ExperienceAdded": "¡Experiencia añadida!",
  "ExperienceSaved": "¡Experiencia guardada!",
  "TellUs": "Cuéntanos sobre ti ... ¡asi podremos personalizar tu experiencia!",
  "JudgeBioSaved": "¡Biografia del juez guardada!",
  "AboutSaved": "¡Acerca de guardado!",
  "SocialLinksSaved": "¡Redes sociales guardadas!",
  "AwsomeWorks": "¡Impresionante trabajo! ¡Ahora tu perfil realmente destaca!",
  "ProfileCompleted": "Perfil completado",
  "TryingToInviteYourself": "Tratando de invitarte a ti mismo, ¿eh?",
  "PersonAlreadyInYourTeam": "Esta persona ya está en tu equipo.",
  "InvitationAlreadySent": "¡Este correo electrónico ya ha sido enviado con una invitación!",
  "UserAlreadyPartOfProject": "Este usuario ya es parte del proyecto o tiene una invitación pendiente.",
  "RoleChanged": "¡Rol cambiado!",
  "TitleChanged": "¡Título cambiado!",
  "ProjectInvitationAccepted": "¡Invitación del proyecto aceptada!",
  "LoginFirst": "Inicia sesión antes de intentar aceptar una invitación a un proyecto.",
  "LoginWithCorrectEmail2": "¡Asegúrate de haber iniciado sesión con el correo electrónico correcto antes de intentar aceptar una invitación al proyecto!",

  "ProjectAboutUpdated": "Informacion sobre el Proyecto actualizada!",
  "ProjectBackdropUploaded": "Fondo del proyecto cargado",
  "SelectAnImage": "Selecciona una imagen para cargar.",
  "ProjectLogoUploaded": "¡Se ha subido el logotipo del proyecto!",
  "ProjectDescriptionUpdated": "¡Descripción del proyecto actualizada!",
  "EnterNote": "Por favor, escribe una nota.",
  "AnswerSaved": "¡Respuesta guardada!",
  "SelectWhoCanView": "Selecciona quién puede ver el builder después de que se haya publicado.",
  "SuccessfullyPublished": "Publicado con éxito.",
  "SuccessfullyUnpublished": "Publicación retirada con éxito.",
  "SendSupportRequest": "Huy! Algo salió mal. Envíenos una solicitud de asistencia para que podamos resolver este problema.",

  "AccountSettingsSaved": "¡Configuración de la cuenta guardada!",
  "ProjectSettingsSaved": "¡Configuración del proyecto guardada!",
  "EmailSettingsSaved": "¡Configuración de email guardada!",
  "ConfirmLeavingProject": "¿Estás seguro de que quieres dejar este proyecto?",
  "NewOwner": "se convertirá en el propietario de este proyecto una vez que se vaya.",
  "LeftTheProject": "¡Has abandonado el proyecto!",
  "HubSettingsSaved": "¡Se guardó la configuración del hub!",

  "ConfirmLeavingPage": "¿Está seguro de que quiere salir de esta página? ¡Cualquier trabajo que no se haya guardado se perderá!",
  "NoGoBack": "No, vuelve",
  "YesClose": "Si, cerrar",
  "EnterValidEmail": "Por favor introduce una dirección de correo electrónico válida.",
  "PasswordMismatch": "Algo raro está sucediendo con tus dos contraseñas - como calcetines que no coinciden.",
  "PasswordTooShort": "Tu contraseña elegida es demasiado corta para ser segura. El mínimo es 6 caracteres.",
  "EmailAddressTaken": "Maldita sea... esa dirección de correo electrónico ya ha sido tomada. Si eres tu, inicia sesión.",
  "PleaseFillAllFields": "Porfavor rellena todos los campos.",

  "EmailAlreadyAssociated": "Esta dirección de correo electrónico ya está asociada a una cuenta.",
  "AlternativeEmailAdded": "Email alternativo añadido. Por favor, comprueba tu buzón de entrada para verificarlo.",

  "DeletedProject": "Proyecto eliminado correctamente",

  "as": "como"
}
